<div mat-dialog-title>Partager une pièce jointe</div>
<div
	mat-dialog-content
	class="flex flex-col"
	[formGroup]="formGroup">
	<div class="flex flex-row items-center">
		<mat-checkbox
			class="flex flex-1"
			formControlName="isSecureEmail">
			{{ "security.email.secure" | translate }}
		</mat-checkbox>
		<button
			mat-icon-button
			(click)="showHelp()">
			<mat-icon>help</mat-icon>
		</button>
	</div>
	<div class="my-4"></div>
	<mat-form-field
		appearance="outline"
		class="w-full">
		<mat-label>{{ "protocol.share.by-email.email" | translate }}</mat-label>
		<input
			matInput
			formControlName="email"
			required />
		<mat-icon matIconPrefix>{{ formGroup.get("isSecureEmail").value ? "mail_lock" : "email" }}</mat-icon>
	</mat-form-field>
</div>
<div
	mat-dialog-actions
	[align]="'end'">
	<button
		mat-button
		mat-dialog-close>
		{{ "core.cancel" | translate }}
	</button>
	@if (isLoading) {
		<mat-spinner [diameter]="40" />
	}
	@if (!isLoading) {
		<button
			mat-raised-button
			color="primary"
			(click)="share()"
			[disabled]="!formGroup.valid">
			{{ "core.share" | translate }}
		</button>
	}
</div>
